






























































import { PropType } from 'vue';
export default {
  name: 'CalendarToolbar',
  props: {
    view: { type: Number, default: 1 },
    roster: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    },
    selectedStreamers: {
      type: Array as PropType<string[]>,
      default: (): string[] => []
    },
    colorMap: {
      type: Object as PropType<Record<string, string>>,
      default: (): Record<string, string> => ({})
    },
    monthLabel: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    removeStreamer(name: string): void {
      this.$emit(
        'update:selectedStreamers',
        this.selectedStreamers.filter((n: string) => n !== name)
      );
    }
  }
};
